module.exports = __webpack_public_path__ + "static/media/i1.7a2c17e8.jpg";